import { Button } from "PFComponents/button";
import { Template } from "PFTypes";
import { useTranslation } from "react-i18next";

type MatchesTimeoutProps = {
  template: Template;
  pending: boolean;
};

export const MatchesTimeout = ({ pending, template }: MatchesTimeoutProps) => {
  const { t } = useTranslation("activities");
  const templateName = t(`templates.${template.key}`);
  const message = pending
    ? t("show.matches.requestTimedOutWait", { templateName })
    : t("show.matches.requestTimedOut");

  return (
    <div style={{ fontSize: 20, display: "flex" }}>
      {message}
      <Button
        text={t("show.matches.clickToReload")}
        kind="text"
        style={{ fontSize: 20, marginLeft: 5 }}
        onClick={() => window.location.reload()}
      />
      .
    </div>
  );
};
